module.exports = __webpack_public_path__ + "static/media/close.f575be54.svg";